import { styled, utilities } from '@creditas/stylitas';

export const BottomLine = styled.div`
  width: 32px;
  height: 4px;
  margin: 8px 0px 15px;

  border-radius: 8px;
  background: ${(props): string =>
    utilities.palette.color(props.theme, 'primary03')};
`;
